<template>
  <div class="container-fluid buy_url">

    <div class="row top-bar">
      <div class="col-12">
        <div class="row header mt-2">
          <div class="col-4"></div>
          <div class="col-4 logo_container" style="text-align: center;">
            <img class="logo ace_sec" :src="logoUrl" alt="institution logo" v-if="institution">
          </div>
          <div class="col-4"></div>
        </div>
      </div>
    </div>

    <div class="row pg_content_container create-section">
      <div class="col-12">


        <template v-if="orgId">
          <template v-if="!buyingInProgress">
            <template v-if="showVerifyEmail">

              <div class="row pg_subhd">
                <div class="col-12">
                  <div class="hd_txt">
                    <span>Verify Email</span>
                  </div>
                  <div class="row hd_msg">
                    <div class="col-12 txt_center" style="margin: auto;">
                      A verification code has been sent to your email.
                    </div>
                    <div class="col-12 txt_center" style="margin: auto;">
                      You will use your email to log in to our learning platform. Please enter the verification code sent to your email. If you don’t see the email, please check your spam or bulk mail folders.
                    </div>
                  </div>
                </div>
              </div>

              <div class="row crd_container">
                <b-card class="col-12 crd">

                  <div class="row fld_row">
                    <div class="col-12 fld_label">
                      Email
                    </div>
                    <div class="col-12 fld_val">
                      <span>{{eMail}}</span>
                    </div>
                  </div>

                  <div class="row fld_row">
                    <div class="col-12	fld_label" id="verificationCode">
                      Verification Code <sup>*</sup>
                    </div>
                    <div class="col-12 fld_input">
                      <b-form-input type="text" v-model.trim="verificationCode" :state="verificationCodeState"
                        placeholder="Verification Code" @input="$v.verificationCode.$touch()"
                        aria-describedby="verificationCodeFeedback">
                      </b-form-input>
                      <b-form-invalid-feedback id="verificationCodeFeedback">
                        Verification Code is required
                      </b-form-invalid-feedback>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 btn_container">
                        <b-button size="lg" @click="verifyEmail" aria-label="verify email" :disabled="!verificationCode">verify email</b-button>
                      </div>
                    </div>


                </b-card>
              </div>

            </template>

            <template v-if="!showVerifyEmail">
              <template v-if="isExistingAccount">

                <div class="row pg_subhd">
                  <div class="col-12">
                    <div class="hd_txt text-center">
                      <span style="font-weight: 800;">Login to finish buying {{programGuide.title}}</span>
                    </div>
                    <div class="row hd_msg">
                      <div class="text-center p-1">
                        Please login with your existing account to enroll in this program
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-7 col-lg-8 col-md-12" style="margin: auto; padding-top: 10px; height: 20px;">
                        <div class="w-100" id="validation-message" style="color: #ff0000; text-align: center;  display: none;" v-html="errorMessage"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div @keydown.enter="login">

                  <div class="row crd_container">
                    <b-card class="col-12 crd price_plan_sec price_plan_sec2">

                      <div class="row sec_hd">
                        <div class="col-12" id="plan_txt">
                          Select Plan
                        </div>
                      </div>

                      <div class="row price_plan_row">
                        <div class="col-12 plan_box" v-for="pricingPlan in programGuide.pricingPlans">
                          <div class="row">
                            <div class="col-1 input_fld">
                              <input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
                            </div>
                            <div class="col-11 val" style="padding-left: 10px; font-weight: 600;">
                              {{pricingPlan.name}} - ${{pricingPlan.price}}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row fld_row">
                        <div class="col-12 lnk_container">
                          <a href="javascript:void(0)" @click="openPricePlanDetailsModal">plan details</a> <a v-if="institution.refundPolicyLink" target="_blank" :href="institution.refundPolicyLink">| refund policy</a>
                        </div>
                      </div>

                      <div class="row sec_hd">
                        <div class="col-12 mt-2 mb-3">
                          login directly into pragya
                        </div>
                      </div>

                      <div class="row fld_row">
                        <div class="col-xl-4 col-lg-4 col-md-12	col-sm-12	fld_label" id="userEmail">
                          Email <sup>*</sup>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-md-12	col-sm-12 fld_input">
                          <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                            aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                            aria-describedby="eMailFeedback">
                          </b-form-input>
                          <b-form-invalid-feedback id="eMailFeedback">
                            This is not a valid email
                          </b-form-invalid-feedback>
                        </div>
                      </div>

                      <div class="row fld_row">
                        <div class="col-xl-4 col-lg-4 col-md-12	col-sm-12	fld_label" id="password">
                          Password <sup>*</sup>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-md-12	col-sm-12 fld_input password_input_fld">
                          <b-form-input v-if="!showPassword" type="password" v-model.trim="password" :state="passwordState"
                            aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                            aria-describedby="passwordFeedback">
                          </b-form-input>
                          <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="passwordState"
                            aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                            aria-describedby="passwordFeedback">
                          </b-form-input>
                          <div class="control">
                            <button class="button" @click="toggleShowPassword" aria-label="View Password">
                              <span class="icon is-small is-right">
                                <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                              </span>
                            </button>
                          </div>
                          <b-form-invalid-feedback id="passwordFeedback">
                            Please provide a valid password.
                          </b-form-invalid-feedback>
                        </div>
                      </div>

                      <div class="row fld_row mb-1">
                        <div class="col-12 fld_label">
                          <div class="row">
                            <div class="col-8 lnk_container pt-3" style="text-align: left;">
                              <a href="javascript:void(0);" @click="forgotPassword">Forgot password</a>
                            </div>
                            <div class="col-4 btn_container" style="padding-left: 1.5rem;">
                              <b-button size="lg" @click="login" :disabled="!enableLogin">login</b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row fld_row">
                        <div class="col-12 fld_label">
                          <div class="row">
                            <div class="col-12 lnk_container pt-0 mt-0" style="text-align: left;">
                              <a href="javascript:void(0);" @click="switchToLogin('signup')">Sign up if you don't have an account</a>
                            </div>
                          </div>
                        </div>
                      </div>


                    </b-card>
                  </div>

                </div>
              </template>

              <template v-if="!isExistingAccount">

                <div class="row pg_subhd">
                  <div class="col-12">
                    <div class="hd_txt">
                      <span style="font-weight: 600;">{{programGuide.title}}</span>
                    </div>
                    <div class="hd_msg p-1">
                      <div v-if="programGuide.buyFlowMessage" v-html="programGuide.buyFlowMessage">
                      </div>
                      <div v-else-if="institution.buyFlowMessage" v-html="institution.buyFlowMessage">
                      </div>
                      <div v-else>
                        Thank you for your interest in enrolling in {{programGuide.title}}. Let's start with your contact information.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row crd_container">
                  <b-card class="col-12 crd price_plan_sec price_plan_sec2">

                    <div class="row sec_hd">
                      <div class="col-12" id="plan_txt">
                        Select Plan
                      </div>
                    </div>

                    <div class="row price_plan_row">
                      <div class="col-12 plan_box" v-for="pricingPlan in programGuide.pricingPlans">
                        <div class="row">
                          <div class="col-1 input_fld">
                            <input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
                          </div>
                          <div class="col-11 val" style="padding-left: 10px; font-weight: 600;">
                            {{pricingPlan.name}} - ${{pricingPlan.price}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row fld_row">
                      <div class="col-12 lnk_container">
                        <a href="javascript:void(0)" @click="openPricePlanDetailsModal">plan details</a> <a v-if="institution.refundPolicyLink" target="_blank" :href="institution.refundPolicyLink">| refund policy</a>
                      </div>
                    </div>

                    <div class="row sec_hd">
                      <div class="col-12">
                        <!--
                        add following details
                        -->
                      </div>
                    </div>

                    <div class="row signup_form_container">
                      <div class="col-12 signup_form_container_inner">

                        <div class="row fld_row signup_form_container">
                          <div class="col-xl-4 col-lg-4 col-md-12	col-sm-12	fld_label" id="firstName">
                            First Name <sup>*</sup>
                          </div>
                          <div class="col-xl-8 col-lg-8 col-md-12	col-sm-12 fld_input">
                            <b-form-input type="text" v-model.trim="firstName" :state="firstNameState"
                              aria-labelledby="firstName" placeholder="First Name" @input="$v.firstName.$touch()"
                              aria-describedby="firstNameFeedback">
                            </b-form-input>
                            <b-form-invalid-feedback id="firstNameFeedback">
                              First Name can not left blank
                            </b-form-invalid-feedback>
                            </div>
                          </div>

                          <div class="row fld_row">
                            <div class="col-xl-4 col-lg-4 col-md-12	col-sm-12 fld_label" id="lastName">
                              Last Name <sup>*</sup>
                            </div>
                            <div class="col-xl-8 col-lg-8 col-md-12	col-sm-12 fld_input">
                              <b-form-input type="text" v-model.trim="lastName" :state="lastNameState"
                                aria-labelledby="lastName" placeholder="Last Name" @input="$v.lastName.$touch()"
                                aria-describedby="lastNameFeedback">
                              </b-form-input>
                              <b-form-invalid-feedback id="lastNameFeedback">
                                Last Name can not left blank
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <div class="row fld_row">
                            <div class="col-xl-4 col-lg-4 col-md-12	col-sm-12 fld_label" id="userEmail">
                              Email <sup>*</sup>
                            </div>
                            <div class="col-xl-8 col-lg-8 col-md-12	col-sm-12 fld_input">
                              <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                                aria-labelledby="email" placeholder="Email" @input="forceEmailLowerCase($event)"
                                aria-describedby="eMailFeedback">
                              </b-form-input>
                              <b-form-invalid-feedback id="eMailFeedback">
                                This is not a valid email
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <div class="row fld_row">
                            <div class="col-xl-4 col-lg-4 col-md-12	col-sm-12 fld_label" id="password">
                              Password <sup>*</sup>
                            </div>
                            <div class="col-xl-8 col-lg-8 col-md-12	col-sm-12 fld_input password_input_fld">
                              <b-form-input v-if="!showPassword" type="password" v-model.trim="password" :state="signupPasswordState"
                                aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                                aria-describedby="passwordFeedback">
                              </b-form-input>
                              <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="signupPasswordState"
                                aria-labelledby="password" placeholder="Password" @input="$v.password.$touch()"
                                aria-describedby="passwordFeedback">
                              </b-form-input>
                              <div class="control">
                                <button class="button" @click="toggleShowPassword" aria-label="View Password">
                                  <span class="icon is-small is-right">
                                    <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                                  </span>
                                </button>
                              </div>
                              <b-form-invalid-feedback id="passwordFeedback">
                                Password should be atleast 8 characters, must contains at least one uppercase letter, one lowercase letter, one number and one special character(@$!%*?&).
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div class="row fld_row">
                        <div class="col-12 fld_label">By Clicking on Sign Up, you accept to the <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">terms of use</a> & <a href="https://site.pragyasystems.com/privacy-policy/" target="_blank">privacy policy</a>.</div>
                      </div>

                      <div class="row fld_row mb-0">
                        <div class="col-7 lnk_container">

                        </div>
                        <div class="col-5 btn_container pl-0 pr-0" style="text-align: right;">
                          <b-button size="lg" @click="createAccount" :disabled="!enableCreateAccount" style="margin-right: 10px;">sign up</b-button>
                        </div>
                      </div>
                      <div class="row fld_row">
                        <div class="col-12 lnk_container mt-0" style="text-align: left;">
                          <a href="javascript:void(0);" @click="switchToLogin('login')">Login if you have an account</a>
                        </div>
                      </div>

                  </b-card>
                </div>

              </template>

            </template>
          </template>
        </template>
        <template v-else>
          <div class="row content-row">
            <div class="col-12">
              <div class="text-center">
                <h4>Link is not valid. Please contact your administrator.</h4>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div>
      <b-modal class="subscribe_modal modal__v22_2 price_plan_modal" id="buy-modal-popup" ref="buyModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

				<div slot="modal-header" class="w-100">
					<div class="row">
						<div class="col-10 hd">
              <div class="ic_container">
                <span class="ic ic22-buy"></span>
              </div>
  	          <div class="hd_txt">
                <span v-if="showPlansPage">Buying - Registration Details</span>
                <span v-if="showSummaryPage">Buying - Payment Details</span>
                <span v-if="showSuccessPage">Buying - Success!</span>
  	          </div>
            </div>
	          <div class="col-2 btn_container">
              <button class="btn_close" aria-label="close" title="close the popup" @click="cancelPurchase">
                <span class="ic-close"></span>
              </button>
	          </div>
					</div>
				</div>

          <div class="row content_container">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form_section">
              <template v-if="showPlansPage">

                <div class="row">
                  <div class="col-12 btn_container action_bar">
                    <b-btn @click.stop.prevent="moveToSummaryPage">
                      <span class="btn_txt">next</span>
                    </b-btn>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 pg_content_inner">

                    <div class="row sub_hd">
    									<div class="col-12 hd_txt">
    										<div class="text-center">{{programGuide.title}}</div>
    									</div>
    								</div>

                    <div class="row price_plan_sec">
    									<div class="col-12 sec_content">

    										<div class="row">

    											<div class="col-12">
    												<div class="row sec_row sec_sub_hd mb-2" v-if="oneTimePlans.length > 0">
    		                      <h5>One Time Plans</h5>
    		                    </div>
    												<div v-if="oneTimePlans.length > 0" class="row sec_row" v-for="pricingPlan in oneTimePlans">
    													<div class="col-1 fld_radio">
    														<input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
    													</div>
    													<div class="col-10">
    														{{pricingPlan.name}} - ${{pricingPlan.price}}
    													</div>
    												</div>
    											</div>

    											<div class="col-12">
    												<div class="row sec_row sec_sub_hd" v-if="subscriptionPlans.length > 0">
    		                      <h5>Subscription Plans</h5>
    		                    </div>
    												<div v-if="subscriptionPlans.length > 0" class="row sec_row" v-for="pricingPlan in subscriptionPlans">
    													<div class="col-1 fld_radio">
    														<input type="radio" name="plan" :value="pricingPlan" v-model="selectedPricingPlan">
    													</div>
    													<div class="col-10">
    														{{pricingPlan.name}} - ${{pricingPlan.price}}
    		                        <span v-if="pricingPlan.type === 'subscription-monthly'">/month</span>
                                <span v-if="pricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>
     		                        <span v-if="pricingPlan.type === 'subscription-yearly'">/year</span>
    													</div>
    												</div>
    											</div>

    										</div>


    										<div class="row">
    											<div class="col-12 lnk_container">
    												<a href="javascript:void(0)" @click="openPricePlanDetailsModal">plan details</a> <a v-if="institution.refundPolicyLink" target="_blank" :href="institution.refundPolicyLink" >| refund policy </a>
    											</div>
    										</div>

    									</div>
    								</div>

                    <div class="row sub_hd student_info">
    									<div class="col-12 hd_txt">
    										<div class="">Student Information</div>
    									</div>
    								</div>

    								<div class="row">
    									<div class="col-12 sec_content">

    										<div class="row fld_row">
    											<div class="col-12 fld_label">
    												 First Name <sup>*</sup>
    											 </div>
    											 <div class="col-12 fld_val">
    												 <input
    		                       type="text"
    		                       class="lms-course-field"
    		                       placeholder="First Name"
    		                       :value="firstNameComputed"
    		                       disabled
    		                       >
    										  </div>
    										</div>

    										<div class="row fld_row">
    											<div class="col-12 fld_label">
    												 Last Name <sup>*</sup>
    											 </div>
    											 <div class="col-12 fld_val">
    												 <input
    	                         type="text"
    	                         class="lms-course-field"
    	                         placeholder="Last Name"
    	                         :value="lastNameComputed"
    	                         disabled
    	                         >
    										  </div>
    										</div>

    										<div class="row fld_row">
    											<div class="col-12 fld_label">
    												 Email <sup>*</sup>
    											 </div>
    											 <div class="col-12 fld_val">
    												 <input
    		                       type="text"
    		                       class="lms-course-field"
    		                       placeholder="Email"
    		                       disabled
    		                       :value="emailComputed"
    		                       >
    										  </div>
    										</div>

                      </div>
                    </div>

									</div>
								</div>
              </template>
              <template v-if="showSummaryPage">
                <template v-if="!showStripeSetupError">

                  <template v-if="!showPaymentLoader">
                    <div class="row">
                      <div class="col-12 btn_container action_bar">
    										<b-btn @click.stop.prevent="moveToPlansPage">
                          <span class="btn_txt">prev</span>
                        </b-btn>
                        <b-btn @click.stop.prevent="moveToSuccessPage">
    											<span class="btn_txt">submit & register</span>
                        </b-btn>
                      </div>
                    </div>
                  </template>

									<template v-if="showPaymentLoader">
                    <div class="text-center">Loading</div>
                  </template>

                  <div class="row">
                    <div class="col-12 pg_content_inner">

                      <div class="row sub_hd">
    										<div class="col-12 hd_txt">
    											<div class="">Order Summary</div>
    										</div>
    									</div>
    									<div class="row">
    										<div class="col-12 sec_content order_summary">
                          <div class="row sec_row">
    												<div class="col-12 plan">
    													{{programGuide.title}}
    												</div>
    											</div>
    											<div class="row sec_row">
    												<div class="col-6 plan">
    													{{selectedPricingPlan.name}}
    												</div>
    												<div class="col-6 price">
    													${{selectedPricingPlan.price}}
                              <span v-if="selectedPricingPlan.type === 'subscription-monthly'">/month</span>

                              <span v-if="selectedPricingPlan.type === 'subscription-monthly-payment-plan'">/month</span>                              
                              <span v-if="selectedPricingPlan.type === 'subscription-yearly'">/year</span>
    												</div>
    											</div>

                          <div class="row sec_row" v-if="couponObj && couponObj.code ">
    												<div class="col-6 plan">
    													{{couponObj.code}}
                              <b-btn @click.stop.prevent="removeCoupon">
                               <span class="btn_txt">remove</span>
                             </b-btn>
    												</div>
    												<div class="col-6 price">
    													 - $ {{discountPrice}}
    												</div>
    											</div>

                          <div class="row fld_row">
    												<div class="col-12 fld_label">
    													 Coupon
    												 </div>
    												 <div class="col-12 fld_val coupon">
    													 <input
    		                         type="text"
    		                         class="lms-course-field"
    		                         placeholder="Add Coupon"
    		                         v-model="coupon"
    		                         >
                                 <b-btn @click.stop.prevent="applyCoupon">
           	                      <span class="btn_txt">apply</span>
           	                    </b-btn>
    											  </div>
                            <div class="col-12 fld_label text-red" v-if="showCouponError">
                              Coupon is invalid. Try another one.
    												 </div>
    											</div>

    											<div class="row sec_row total">
    												<div class="col-6 plan">
    													Total
    												</div>
    												<div class="col-6 price">
    													${{finalPrice}}
                              <span v-if="selectedPricingPlan.type === 'subscription-monthly'">/month</span>
                              <span v-if="selectedPricingPlan.type === 'subscription-monthly-payment-plan'">/month</span> 
                              <span v-if="selectedPricingPlan.type === 'subscription-yearly'">/year</span>
    												</div>
    											</div>

    										</div>
    									</div>

                      <template v-if="finalPrice > 0">
      									<div class="row sub_hd">
      										<div class="col-12 hd_txt">
      											<div class="">Payment</div>
      										</div>
      									</div>
                        <template v-if="selectedPricingPlan.type !== 'onetime' && paymentMethodsToShow.length > 0 ">
                          <div class="row payment">
                            <div class="col-12 sec_content">
                              <div class="row fld_row">
                                <div class="col-12 fld_label">
                                  Use An  Existing Pay
                                </div>
                                <div class="col-12 row" v-for="userPaymentMethod in paymentMethodsToShow">
                                  <div class="col-1 fld_radio">
        														<input type="radio" name="plan" :value="userPaymentMethod" v-model="selectedPaymentMethod">
        													</div>
                                  <div class="col-xl-3 col-lg-5 col-md-11 col-sm-11 pt-2">
                                    <div class="card__number info_val2">
                                      <span class="info_title2 pt-1">****</span>
                                      <span class="info_val2">{{userPaymentMethod.lastFour}}</span>
                                    </div>
                                  </div>
                                  <div class="col-xl-3 col-lg-5 col-md-11 col-sm-11 pt-2">
                                    <div class="expiry_date">
                                      <span class="info_title2">expiry:</span>
                                      <span class="info_val2">{{userPaymentMethod.expiration}}</span>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="row payment">
                            <div class="col-12 sec_content">
                              <div class="row fld_row">
                                <div class="col-12 fld_label" v-if="selectedPaymentMethod.uuid === ''">
                                  Or
                                </div>
                                <div class="col-12 fld_label" v-if="selectedPaymentMethod.uuid !== ''">
                                  <b-btn @click.stop.prevent="clearAndAddNewPayment">
                                    <span class="btn_txt">Add new card instead</span>
                                  </b-btn>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
      									<div class="row payment" v-if="selectedPaymentMethod.uuid === ''">
      										<div class="col-12 sec_content">
      											<div class="row fld_row">
      												<div class="col-12 fld_label">
      													Credit Card Details
      												</div>
      												<div class="col-12">
      													<div ref="card" id="card-element"></div>
      												</div>
      											</div>
      										</div>
      									</div>


      									<div class="row sub_hd">
      										<div class="col-12 hd_txt">
      											<div class="">Billing Information</div>
      										</div>
      									</div>
      									<div class="row">
      										<div class="col-12 sec_content">

      											<div class="row sec_row">
      												<div class="col-12 mb-2">
      													<input
                            			style="width:10%!important;"
                              		type="checkbox"
                              		class="lms-course-field"
                              		v-model="sameAsStudent"
                              	> same as student information
      												</div>
      											</div>

      											<div class="row fld_row">
      												<div class="col-12 fld_label">
      													 First Name*
      												 </div>
      												 <div class="col-12 fld_val">
      													 <input
      		                         type="text"
      		                         class="lms-course-field"
      		                         placeholder="First Name"
      		                         v-model="billingFirstName"
      		                         >
      											  </div>
      											</div>

      											<div class="row fld_row">
      												<div class="col-12 fld_label">
      													 Last Name*
      												 </div>
      												 <div class="col-12 fld_val">
      													 <input
      	                           type="text"
      	                           class="lms-course-field"
      	                           placeholder="Last Name"
      	                           v-model="billingLastName"
      	                           >
      											  </div>
      											</div>

      											<div class="row fld_row">
      												<div class="col-12 fld_msg">
      													<p v-if="showMissingBillingInfoError" class="text-red">First Name & Last Name are required.</p>
      													<p v-if="showPaymentFailureError" class="text-red">Payment Failed. Please try again.</p>
      												</div>
      											</div>

      										</div>
      									</div>
                      </template>

                    </div>
                  </div>

								</template>
                <template v-if="showStripeSetupError">
									<div class="row sub_hd mt-3">
										<div class="col-6 hd_txt">
											<div class=""></div>
										</div>
									</div>
									<div class="row mb-5">
										<div class="col-12">
											<div class="row sec_row">
												<div class="col-12">
													There was error in setup. Please reach out to
													<a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
												</div>
											</div>
										</div>
									</div>
                </template>
              </template>
              <template v-if="showSuccessPage">
								<div class="row sub_hd mt-2">
									<div class="col-6 hd_txt">
										<div class=""></div>
									</div>
								</div>
								<div class="row mb-5">
									<div class="col-12">
										<div class="row sec_row">
											<div class="col-12">
												Congratulations! You have successfully enrolled in {{programGuide.title}}. Get started now!
											</div>
										</div>

										<div class="row sec_row">
											<div class="col-12 btn_container2">
												<a class="btn" @click="redirectToLearnerDashboard">Go to Home Page</a>
											</div>
										</div>
									</div>
								</div>

							</template>
            </div>
	  			</div>

      </b-modal>
    </div>
    <div>
      <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :header-bg-variant="'warning'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center" @keydown.enter="resetPassword">
          <template v-if="resetPasswordMessage">
            <span style="color: Red;">{{resetPasswordMessage}}</span>
          </template>
          <template v-else>
            <div class="float-left mr-3">
              <div class="fld-label">User Email</div>
            </div>
            <div class="ml-5">
              <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                aria-labelledby="reset email" placeholder="Email" @blur.native="$v.resetPasswordEmail.$touch()"
                aria-describedby="resetPasswordEmailFeedback" style="height: 1.5em !important; width: 70%;">
              </b-form-input>
              <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                Please enter a proper email address.
              </b-form-invalid-feedback>
            </div>
          </template>
        </div>
        <div slot="modal-footer" class="w-100">
          <template v-if="resetPasswordMessage">
            <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">ok</b-button>
          </template>
          <template v-else>
            <b-button variant="primary" size="sm" class="float-right ml-3" @click="resetPassword">get new password</b-button>
            <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">cancel</b-button>
          </template>
        </div>
      </b-modal>
    </div>

    <!-- Price Plan Detials Modal -->
		<div>
			<b-modal id="pricePlanDetails" ref="pricePlanDetailsModal" class="subscribe_modal modal__v22_2 price_plan_modal price_plan_details_modal" :header-bg-variant="'credential-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

			  <div slot="modal-header" class="w-100">
					<div class="row">
						<div class="col-10 hd">
							<div class="ic_container">
								<span class="ic ic22-buy"></span>
							</div>
              <div class="hd_txt text-center w-100" style="margin-left: 0px;">
								<span>Pricing Plan for {{programGuide.title}}</span>
							</div>
						</div>
            <div class="col-2 btn_container">
							<button class="btn_close" aria-label="close" title="close the popup" @click="closePricePlanDetailsModal">
								<span class="ic-close"></span>
							</button>
						</div>
					</div>
				</div>

        <div class="row content_container" style="max-width: 100%;">
          <div class="col-12">

            <div class="row" v-if="oneTimePlans.length > 0">
              <div class="col-12 sec_sub_hd">
                <h5>One Time Plans</h5>
              </div>
            </div>
						<div class="row plans_container">
							<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 plan_box" v-for="pricingPlan in oneTimePlans">
								<div class="plan_box_inner">

									<div class="row hd">
										<div class="col-xl-9 col-lg-8 col-md-8 col-sm-8 sec_hd">
			              	{{pricingPlan.name}}
										</div>
										<div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 price">
											${{pricingPlan.price}}
										</div>
									</div>

									<div class="row description_long">
		              	<div class="col-12" v-html="pricingPlan.description"></div>
									</div>

									<div class="btn_container">
		              	<a @click="selectFromPricingPlan(pricingPlan)" class="btn">Select</a>
									</div>
		            </div>
							</div>
            </div>

            <div class="row" v-if="subscriptionPlans.length > 0">
							<div class="col-12 sec_sub_hd">
								<h5>Subscription Plans</h5>
							</div>
            </div>
            <div class="row plans_container">
							<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 plan_box" v-for="pricingPlan in subscriptionPlans">
								<div class="plan_box_inner">

									<div class="row hd">
										<div class="col-xl-9 col-lg-8 col-md-8 col-sm-8 sec_hd">
			              	{{pricingPlan.name}}
										</div>
										<div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 price">
											${{pricingPlan.price}}
										</div>
									</div>

									<div class="row description_long">
		              	<div class="col-12" v-html="pricingPlan.description"></div>
									</div>

									<div class="btn_container">
		              	<a @click="selectFromPricingPlan(pricingPlan)" class="btn">Select</a>
									</div>
		            </div>
							</div>
            </div>

					</div>
        </div>

			</b-modal>
		</div>
		<!-- Plan Detials Modal -->

  </div>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required, email, minLength} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  import { setItem } from '../../../storage'

  export default {
    name: 'buyUrl',
    data: () => {
      return {
        orgId: null,
        eMail: '',
        firstName: '',
        lastName: '',
        password: '',
        showPassword: false,
        verificationCode: '',
        showVerifyEmail: false,
        showNextPopup : false,
        isExistingAccount: false,
        roles: {role: 'Student'},
        userProfile: {courses: [], areaOfInterest: [], experience: '', bio: ''},
        institution: null,
        errorMessage: '',
        showForgotPasswordModal: false,
        resetPasswordEmail: '',
        resetPasswordMessage: null,
        cipCode: '',
        code: '',
        type: '',
        programGuide: {},
        showPlansPage: false,
        showSummaryPage: false,
        showSuccessPage: false,
        selectedPricingPlan: {},
        stripe: undefined,
        elements: undefined,
        card: undefined,
        stripeCredentials: {},
        showStripeSetupError: false,
        billingFirstName: '',
        billingLastName: '',
        sameAsStudent: true,
        showMissingBillingInfoError: false,
        showPaymentFailureError: false,
        showPaymentLoader: false,
        buyingInProgress: false,
        coupon: '',
        couponObj: {},
        showCouponError: false,
        userPaymentMethods: [],
        selectedPaymentMethod: {
          uuid: ''
        }
      }
    },
    validations: {
      eMail: {
        required,
        email
      },
      firstName: {
        required
      },
      lastName: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      },
      verificationCode: {
        required
      },
      resetPasswordEmail: {
        required,
        email
      }
    },
    async created () {
      this.resetData()
      this.orgId = this.getQueryParamByName('orgId')
      this.eMail = this.getQueryParamByName('email')
      this.cipCode = this.getQueryParamByName('cipCode')
      this.code = this.getQueryParamByName('code')
      this.type = this.getQueryParamByName('type')

      let utm_medium = this.getQueryParamByName('utm_medium')
      localStorage.setItem('utm_medium', utm_medium)
      let utm_source = this.getQueryParamByName('utm_source')
      localStorage.setItem('utm_source', utm_source)
      let utm_campaign = this.getQueryParamByName('utm_campaign')
      localStorage.setItem('utm_campaign', utm_campaign)
      let utm_content = this.getQueryParamByName('utm_content')
      localStorage.setItem('utm_content', utm_content)
      let utm_term = this.getQueryParamByName('utm_term')
      localStorage.setItem('utm_term', utm_term)

      this.institution = await this.loadInstitutionMetaInfoForSelfRegistration(this.orgId)
      let root = document.documentElement;
      root.style.setProperty("--TU__BaseTxtClr", this.institution.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__BtnClrPri", this.institution.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnTxtClrPri", this.institution.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnHoverClrPri", this.institution.buttonHoverColor); //Button Hover Color
      root.style.setProperty("--TU__BtnTxtHoverClrPri", this.institution.secondaryColor); // Button Text Color
      root.style.setProperty("--TU__BtnClrSec", this.institution.primaryColor); // Button Color
      root.style.setProperty("--TU__BtnHoverClrSec", this.institution.buttonHoverColor);  //Button Hover Color
      root.style.setProperty("--TU__LnkClrPri", this.institution.linkColor); // Link Color
      root.style.setProperty("--TU__LnkHoverClrPri", this.institution.linkHoverColor); // Link Hover Color
      root.style.setProperty("--TU__LnkClrSec", this.institution.backgroundColor); // Other Text Color
      root.style.setProperty("--TU__LnkHoverClrSec", this.institution.backgroundColor); // Other Text Color

      this.programGuide = await this.loadProgramGuideByCodeAndInstitutionId({code: this.code, cipCode: this.cipCode, type: this.type, institutionId: this.orgId})
      if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
          this.selectedPricingPlan = this.programGuide.pricingPlans[0]
      }


      if (!this.isSessionExpired()) {
        this.showBuyFlow()
      }
      this.loadLogDashboardActivity({action: 'buyurl', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title})
    },
    mounted () {
      if (this.eMail) {
        this.showVerifyEmail = true
      }
      this.showNextPopup= false
    },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj
      }),
      eMailState () {
        return (this.eMail.length === 0) ? null : !this.$v.eMail.$error
      },
      firstNameState () {
        return (this.firstName.length === 0) ? null : !this.$v.firstName.$error
      },
      lastNameState () {
        return (this.lastName.length === 0) ? null : !this.$v.lastName.$error
      },
      passwordState () {
        return (this.password.length === 0) ? null : !this.$v.password.$error
      },
      signupPasswordState () {
        var basicValidation = (this.password.length === 0) ? null : !this.$v.password.$error
        if(basicValidation){
            var basicValidation = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(this.password)
        }
        return basicValidation
      },
      verificationCodeState () {
        return (this.verificationCode.length === 0) ? null : !this.$v.verificationCode.$error
      },
      resetPasswordEmailState () {
        return (this.resetPasswordEmail.length === 0) ? null : !this.$v.resetPasswordEmail.$error
      },
      enableCreateAccount () {
        return (this.firstNameState && this.lastNameState && this.eMailState && this.passwordState && this.password.length >= 6)
      },
      enableLogin () {
        return (this.eMailState && this.passwordState && this.password.length >= 6)
      },
      logoUrl () {
        if (this.institution) {
          if (this.institution.logoUrl) {
            return this.institution.logoUrl
          } else {
            return 'https://site.pragyasystems.com/wp-content/uploads/2016/04/pragyaLogo.png'
          }
        }
        return null
      },
      firstNameComputed () {
        return this.userObj.firstName
      },
      lastNameComputed () {
        return this.userObj.lastName
      },
      emailComputed () {
        return this.userObj.eMail
      },
      minPrice () {
        let minPrice = 0
        if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
          minPrice = this.programGuide.pricingPlans[0].price
          this.programGuide.pricingPlans.forEach((item, i) => {
            if (item.price < minPrice) {
              minPrice = item.price
            }
          })
        }
        if (minPrice === 0) {
          return 'Free'
        }
        return '$' + minPrice
      },
      isPricingAvailable () {
        if (this.programGuide && this.programGuide.pricingPlans.length > 0) {
          return true
        }
      },
      finalPrice () {

        if (this.selectedPricingPlan && this.couponObj && this.couponObj.code) {
          let price = this.selectedPricingPlan.price
          if (this.couponObj.type === 'flat') {
            price = price - this.couponObj.value
            if (price < 0) {
              price = 0
            }
            price = price.toFixed(2)
          } else  if (this.couponObj.type === 'percentage') {
            let discount = (price * this.couponObj.value) / 100
            discount = discount.toFixed(2)
            price = price - discount
            if (price < 0) {
              price = 0
            }
            price = price.toFixed(2)
          }
          return price
        }

        if (this.selectedPricingPlan) {
          return this.selectedPricingPlan.price
        }
      },
      discountPrice () {
        if (this.selectedPricingPlan && this.couponObj && this.couponObj.code) {
          let price = this.selectedPricingPlan.price
          if (this.couponObj.type === 'flat') {
            return this.couponObj.value
          } else  if (this.couponObj.type === 'percentage') {
            let discount = (price * this.couponObj.value) / 100
            return discount.toFixed(2)
          }
        }

        return 0
      },
      oneTimePlans () {
        let plans = []
        if (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length > 0) {
          this.programGuide.pricingPlans.forEach((item, i) => {
            if (item.type === 'onetime') {
              plans.push(item)
            }
          })
        }
        return plans
      },
      subscriptionPlans () {
        let plans = []
        if (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length > 0) {
          this.programGuide.pricingPlans.forEach((item, i) => {
            if (item.type !== 'onetime') {
              plans.push(item)
            }
          })
        }
        return plans
      },
      paymentMethodsToShow () {
        let methods = []
        this.userPaymentMethods.forEach((item, i) => {
          let details = JSON.parse(item.stripePaymentMethod)
          item.expiration = details.card.exp_month + '/' + details.card.exp_year
          item.brand = details.card.brand
          methods.push(item)
        })
        return methods
      }
    },
    watch: {
      sameAsStudent (newSameAsStudent) {
        if (!newSameAsStudent) {
          this.billingFirstName = ''
          this.billingLastName = ''
        } else {
          this.billingFirstName = this.firstNameComputed
          this.billingLastName = this.lastNameComputed
        }
      }
    },
    methods: {
      ...mapActions([
        'loadLearnerSelfRegistration',
        'loadVerifySelfRegistration',
        'loadInstitutionMetaInfoForSelfRegistration',
        'loadResetPassword',
        'loadUserLogin',
        'loadProgramGuideByCodeAndInstitutionId',
        'loadUpdateUserObj',
        'loadSaveEnrollmentStatus',
        'loadUserSubscriptions',
        'loadGetInstitutionPaymentPublicCredentials',
        'loadPutCreatePaymentIntent',
        'loadPutFinalizePaymentIntent',
        'loadGetCheckValidityOfCoupon',
        'loadGetCouponCode',
        'loadLogDashboardActivity',
        'loadUserPaymentMethods',
        'loadCreateUserPaymentMethod',
        'loadCreateSubscription'
      ]),
      showLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$parent.$refs.loadingModal) {
          this.$parent.$refs.loadingModal.hide()
        }
      },
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      },
      forceEmailLowerCase (e) {
        e = e.trim().toLowerCase()
        this.$set(this.$data, 'eMail', e)
        this.$v.eMail.$touch()
      },
      resetData () {
        this.orgId = ''
        this.resetLoginSignupData()
        this.isExistingAccount = false
      },
      createAccount () {
        this.$v.eMail.$touch()
        this.$v.firstName.$touch()
        this.$v.lastName.$touch()
        this.$v.password.$touch()
        if (this.firstNameState && this.lastNameState && this.eMailState && this.passwordState) {
          this.showLoader()
          let userObj = {
            eMail: this.eMail,
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            userProfile: this.userProfile,
            sendSelfRegistrationVerificationEmail: true
          }
          this.loadLearnerSelfRegistration({orgId: this.orgId, user: userObj}).then(res => {
            if (res) {
              if (res.accountExists) {
                this.hideLoader()
                this.$notify({
                  group: 'notify',
                  type: 'error',
                  title: '',
                  text: 'An Account already exists with email "' + this.eMail + '" . Login or use different email.'
                })
              } else {
                this.hideLoader()
                this.showVerifyEmail = true
                let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                this.loadLogDashboardActivity({action: 'signup', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})
                this.loadLogDashboardActivity({action: 'verifyEmailSent', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

              }
            } else {
              this.hideLoader()
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Please try again. Note that this email "' + this.eMail + '" might already be taken.'
              })
            }
          })
        }
      },
      async verifyEmail () {
        this.$v.verificationCode.$touch()
        if (this.verificationCodeState) {
          let userObj = {
            eMail: this.eMail,
            institutionId: this.orgId,
            verificationCode: this.verificationCode
          }
          let response = await this.loadVerifySelfRegistration(userObj)
          let status = response.status
          let data = response.data
          if (status === 200) {
            if (data === 'invalid_verification_code') {
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'Your verification code is incorrect or expired.'
              })
            } else {
              this.$parent.isUserLoggedIn = true
              this.moveToSummaryPage()
              this.showNextPopup = true
              this.$refs.buyModal.show()

              let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
              this.loadLogDashboardActivity({action: 'eMailVerified', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

              this.loadLogDashboardActivity({action: 'beginPayment', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

            }
          }
        }
      },
      resetLoginSignupData () {
        this.eMail = ''
        this.firstName = ''
        this.lastName = ''
        this.password = ''
        this.verificationCode = ''
      },
      switchToLogin (action) {
        this.resetLoginSignupData()
        if (action === 'login') {
          let path = this.institution.path
          let ssoUrl = this.institution.ssoUrl
          if (path && ssoUrl) {
            window.open(window.location.origin + '/sso/' + path, '_self')
          } else {
            this.restoredSessionFromToken()
          }
        } else {
          this.isExistingAccount = false
        }
      },
      login () {
        this.$v.eMail.$touch()
        this.$v.password.$touch()
        if (this.eMailState && this.passwordState) {
          this.showLoader()
          this.loadUserLogin({eMail: this.eMail, password: this.password, institutionId: this.institution.institutionId}).then(res => {
            let status = res.status
            let userObj = res.data
            if (status === 200) {
              this.hideLoader()
              let role = userObj.roles[0].role
              if (userObj.institutionId !== this.institution.institutionId) {
                this.errorMessage = '<b>' + this.eMail + '</b> does not exist in <b>' + this.institution.title + '</b>. Please contact your administrator.'
              }
              if (role !== this.roles.role) {
                this.errorMessage = 'You don\'t have a <b>Learner account</b> in <b>' + this.institution.title + '</b>. Please contact your administrator.'
              }
              if (!this.errorMessage || (this.errorMessage.length === 0)) {
                this.$parent.isUserLoggedIn = true
                this.showNextPopup = true
                this.showBuyFlow()
                this.loadLogDashboardActivity({action: 'signin', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,userObj})
              }
            } else {
              this.hideLoader()
                let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                this.loadLogDashboardActivity({action: 'signinFail', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

              switch (status) {
                case 503:
                  this.errorMessage = 'Server temporarily unavailable'
                  break
                case 401:
                  this.errorMessage = 'Invalid email or password'
                  break
                case 400:
                  this.errorMessage = 'Please enter all required fields'
                  break
                default:
                  this.errorMessage = 'Unexpected error code: ' + status
                  break
              }
            }
            if (this.errorMessage.length > 0) {
              $('#validation-message').fadeIn('fast').delay(3000).fadeOut('slow')
            }
          })
        }
      },
      forgotPassword () {
        this.resetPasswordEmail = ''
        this.resetPasswordMessage = null
        this.showForgotPasswordModal = true
        this.$v.resetPasswordEmail.$touch()
      },
      toggleShowPassword () {
        this.showPassword = !this.showPassword;
      },
      resetPassword () {
        this.$v.resetPasswordEmail.$touch()
        if (this.resetPasswordEmailState) {
          this.loadResetPassword(this.resetPasswordEmail).then(res => {
            let status = res.status
            switch (status) {
              case 401:
                this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
                break
              case 500:
                this.resetPasswordMessage = 'Error in service call.'
                break
              default:
                this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
                break
            }
          })
        }
      },
      isSessionExpired () {
        let token = localStorage.getItem('token')
        if (token) {
          let loginTime = localStorage.getItem('loginTime')
          let currentTime = (new Date()).getTime()
          let currentSessionDuration = (currentTime - loginTime) / 60000
          return (currentSessionDuration > 480)
        }
        return true
      },
      restoredSessionFromToken () {
        if (this.isSessionExpired()) {
          this.isExistingAccount = true
        } else {
          let role = localStorage.getItem('userrole')
          let institutionId = localStorage.getItem('institutionId')
          if ((institutionId === this.institution.institutionId) && (role === this.roles.role)) {
            this.$parent.isUserLoggedIn = true
            // return this.$router.push('/user/track/student')
            this.showBuyFlow()
          } else {
            localStorage.clear()
            this.isExistingAccount = true
          }
        }
      },
      selectFromPricingPlan (pricingPlan) {
        this.showSummaryPage = false
        this.showSuccessPage = false
        this.selectedPricingPlan = pricingPlan
        this.showMissingBillingInfoError = false,
        this.showPaymentFailureError = false
        if (this.showNextPopup) {
          this.$refs.buyModal.show()
          this.showPlansPage = true
        } else {
          this.$refs.pricePlanDetailsModal.hide()
        }
      },
      showBuyFlow () {
        this.buyingInProgress = true
        this.showPlansPage = true
        this.showSummaryPage = false
        this.showSuccessPage = false
        if (!this.selectedPricingPlan && this.programGuide.pricingPlans.length > 0) {
          this.selectedPricingPlan = this.programGuide.pricingPlans[0]
        }
        this.showMissingBillingInfoError = false,
        this.showPaymentFailureError = false
        this.$refs.buyModal.show()
      },
      closeBuyModal () {
        if (this.card) {
          this.card.unmount()
          $('#card-element').removeClass('form-control')
        }
        this.showPlansPage = true
        this.showSummaryPage = false
        this.showSuccessPage = false
        this.$refs.buyModal.hide()
      },
      async moveToSummaryPage () {
        this.userPaymentMethods = await this.loadUserPaymentMethods()
        this.stripeCredentials = await this.loadGetInstitutionPaymentPublicCredentials(this.programGuide.institutionId)
        if (this.stripeCredentials) {
          if (this.selectedPricingPlan.type === 'onetime') {
            this.stripe = Stripe(this.stripeCredentials.publicKey, {
              stripeAccount: this.stripeCredentials.accountId
            })
          } else {
            this.stripe = Stripe(this.stripeCredentials.publicKey)
          }
          this.elements = this.stripe.elements()
          setTimeout(() => {
            this.card = this.elements.create('card')
            this.card.mount('#card-element')
            $('#card-element').addClass('form-control')
            this.showCardLoader = false
          }, 1500);
        } else {
          this.showStripeSetupError = true
        }
        if (this.billingLastName.length < 1) {
          this.billingLastName = this.lastNameComputed
        }

        if (this.billingFirstName.length < 1) {
          this.billingFirstName = this.firstNameComputed
        }
        this.showPlansPage = false
        this.showSummaryPage = true
        this.showSuccessPage = false
      },
      moveToPlansPage () {
        this.card.unmount()
        this.selectedPaymentMethod = {
          uuid: ''
        }
        $('#card-element').removeClass('form-control')
        this.showPlansPage = true
        this.showSummaryPage = false
        this.showSuccessPage = false
      },
      async moveToSuccessPage () {
        if (this.billingFirstName.length <= 0 || this.billingLastName.length <= 0) {
          this.showMissingBillingInfoError = true
        } else {

          if (this.selectedPricingPlan.type === 'subscription-monthly' || this.selectedPricingPlan.type === 'subscription-yearly' || this.selectedPricingPlan.type === 'subscription-monthly-payment-plan'){
            this.showPaymentLoader = true
            this.loadLogDashboardActivity({action: 'stripeInit', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

            // Create/Update Payment Method
            if (this.selectedPaymentMethod.uuid === '') {
              let result = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.card,
                billing_details: {
                  name: this.billingFirstName + ' ' + this.billingFirstName,
                  email: this.emailComputed
                }
              })
              if (result.error) {
                this.showPaymentLoader = true
              } else {
                let paymentMethodObj = {
                  paymentMethodId: result.paymentMethod.id
                }
                this.selectedPaymentMethod = await this.loadCreateUserPaymentMethod(paymentMethodObj)
              }
            }

            // Create Subscription (we dont calculate final price here because Stripe will adjust using stripe coupon)
            let finalPrice = this.finalPrice
            let couponId = this.couponObj && this.couponObj.code ? this.couponObj.uuid: ''

            let transactionObj = {
              entityId: this.programGuide.uuid,
              entityType: 'program',
              price: finalPrice,
              currency: this.selectedPricingPlan.currency,
              pricingPlanId: this.selectedPricingPlan.uuid,
              pricingPlanLearner: this.selectedPricingPlan,
              stripeProductId: this.selectedPricingPlan.stripeProductId,
              stripePriceId: this.selectedPricingPlan.stripePriceId,
              paymentMethodId: this.selectedPaymentMethod.uuid,
              type: 'firsttime',
              couponCodeId: couponId
            }

            let transactionResponse = await this.loadCreateSubscription(transactionObj)

            // Enroll user in program
            this.enrollmentStatus = 'INPROGRSS'
            let currentUserObj = this.userObj
            currentUserObj.enrollmentStatus = 'INPROGRSS'
            currentUserObj.major1 = this.programCode
            await this.loadUpdateUserObj(currentUserObj)
            await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
            await this.$root.$emit('reloadLearnerDashboard')
            this.showPaymentLoader = false
            this.card.unmount()
            $('#card-element').removeClass('form-control')
            this.showPlansPage = false
            this.showSummaryPage = false
            this.showSuccessPage = true
            this.loadLogDashboardActivity({action: 'stripeSuccess', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})
            this.loadLogDashboardActivity({action: 'buyComplete', page: 'prgramSummary', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code})

          } else {
            // One Time transaction starts
            this.showMissingBillingInfoError = false
            this.showPaymentLoader = true

            let finalPrice = this.finalPrice
            let couponId = this.couponObj && this.couponObj.code ? this.couponObj.uuid: ''

            let transactionObj = {
              entityId: this.programGuide.uuid,
              entityType: 'program',
              price: finalPrice,
              currency: this.selectedPricingPlan.currency,
              pricingPlanId: this.selectedPricingPlan.uuid,
              pricingPlanLearner: this.selectedPricingPlan,
              type: 'firsttime',
              couponCodeId: couponId
            }
            let transactionResponse = await this.loadPutCreatePaymentIntent(transactionObj)

            if (finalPrice > 0) {
              let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
              this.loadLogDashboardActivity({action: 'stripeInit', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

              let result = await this.stripe.confirmCardPayment(transactionResponse.paymentIntentObject, {
                payment_method: {
                  card: this.card,
                  billing_details: {
                    name: this.billingFirstName + ' ' + this.billingFirstName,
                    email: this.emailComputed
                  }
                }
              })

              if (result.error) {
                // Show error to your customer (e.g., insufficient funds)
                this.showPaymentFailureError = true
                this.showPaymentLoader = false
                let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                this.loadLogDashboardActivity({action: 'stripeError', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,'preUser': preUser, 'stripeError': result.error.code})

              } else {
                this.showPaymentFailureError = false
                // The payment has been processed!
                if (result.paymentIntent.status === 'succeeded') {
                  // call finalize Sale
                  await this.loadPutFinalizePaymentIntent(transactionResponse.uuid)
                  // Enroll user in program
                  this.enrollmentStatus = 'INPROGRSS'
                  let currentUserObj = this.userObj
                  currentUserObj.enrollmentStatus = 'INPROGRSS'
                  currentUserObj.major1 = this.programCode
                  await this.loadUpdateUserObj(currentUserObj)
                	await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
                	await this.$root.$emit('reloadLearnerDashboard')
                  this.showPaymentLoader = false
                  this.card.unmount()
                  $('#card-element').removeClass('form-control')
                  this.showPlansPage = false
                  this.showSummaryPage = false
                  this.showSuccessPage = true
                  let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
                  this.loadLogDashboardActivity({action: 'stripeSuccess', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

                  // Paid Purchase
                  this.loadLogDashboardActivity({action: 'buyComplete', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

                }
              }
            } else {
              // call finalize Sale
              await this.loadPutFinalizePaymentIntent(transactionResponse.uuid)
              // Enroll user in program
              this.enrollmentStatus = 'INPROGRSS'
              let currentUserObj = this.userObj
              currentUserObj.enrollmentStatus = 'INPROGRSS'
              currentUserObj.major1 = this.programCode
              await this.loadUpdateUserObj(currentUserObj)
              await this.loadSaveEnrollmentStatus({programCode: this.programGuide.code, status: this.enrollmentStatus})
              await this.$root.$emit('reloadLearnerDashboard')
              this.showPaymentLoader = false
              this.card.unmount()
              $('#card-element').removeClass('form-control')
              this.showPlansPage = false
              this.showSummaryPage = false
              this.showSuccessPage = true
              // Coupon 100% purchase
              let preUser = {firstName:this.firstName,lastName:this.lastName,eMail:this.eMail}
              this.loadLogDashboardActivity({action: 'buyComplete', page: 'buyurl', link: '', 'entityUuid':'', 'programCipCode':this.cipCode, 'careerSocCode':'', 'programCode':this.code, 'preLoginInstitutionId':this.orgId, 'preLoginInstitutionName':this.institution.title,preUser})

            }

            // One Time transaction ends
          }
        }
      },
      redirectToLearnerDashboard () {
        this.$parent.isBuyUrl = false
        return this.$router.push({name: 'dashboard'})
      },
      cancelPurchase () {
        this.$parent.isServiceAvailable = true
        this.$parent.isBuyUrl = false
        return this.$router.push({name: 'dashboard'})
      },
      openPricePlanDetailsModal () {
  			this.$refs.pricePlanDetailsModal.show()
  		},
  		closePricePlanDetailsModal () {
  			this.$refs.pricePlanDetailsModal.hide()
        if(this.showNextPopup) {
          this.showBuyFlow()
        }
  		},
      async applyCoupon () {
        this.showCouponError = false
        // check if the coupon is valid
        let responsValidity = await this.loadGetCheckValidityOfCoupon({couponCode: this.coupon, programCode: this.programGuide.code, pricingPlanId: this.selectedPricingPlan.uuid})
        if (responsValidity) {
          // if the coupon is valid get coupon information
          this.couponObj = await this.loadGetCouponCode(this.coupon)
        } else {
          this.showCouponError = true
        }
      },
      async removeCoupon () {
        this.coupon = ''
        this.couponObj = {}
      }
    }
  }
</script>

<style scoped>
  .top-bar {
    height: 50px;
    padding-top: 0;
    background: #f5f5f5;
  }
  .content-section {
    float: left;
    width: 100%;
    margin-top: 25px;
    background: #f5f5f5;
    border: 1px solid #e3e3e3;
    padding: 20px;
    border-radius: 0;
  }
  .sec_hd {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    border-bottom: none;
  }
  .fld_row {
    margin-bottom: 15px;
  }
  .fld_label {
    text-align: left;
    padding-bottom: 5px;
    margin: auto;
    max-width: 450px;
  }
  .create-section .content-section sup {
    color: red;
    font-size: 17px;
    top: -2px;
    left: 2px;
  }
  .popup_head_txt {
    font-size: 1.1rem;
    width: 75%;
    color: #323232;
  }
  .password_input_fld .control {
    right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/app/login/components/BuyUrl.vue